<template>
  <card shadow class="card-profile b-2" style="width: 100%; color: black;" no-body>
    <div class="px-4">
      <!-- Хайлт болон Шинэ үүсгэх товч -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h1 class="display-3 mt-3">Хичээлийн төрлийн жагсаалт</h1>
        <div class="d-flex align-items-center">
          <input type="text" v-model="searchQuery" class="form-control mr-2" placeholder="Нэр эсвэл утгаар хайх..." />
          <button class="btn btn-success" @click="openCreateModal">Үүсгэх</button>
        </div>
      </div>

      <table class="table" v-if="filteredTypeList.length">
        <thead>
          <tr>
            <th>
              <button class="btn btn-link" @click="toggleSort">
                ID
                <i :class="sortDirection === 'asc' ? 'fa fa-sort-up' : 'fa fa-sort-down'"></i>
              </button>
            </th>
            <th>Хичээлийн төрөл / Түлхүүр үг</th>

          </tr>
        </thead>
        <tbody>
          <tr v-for="lessonType in filteredTypeList" :key="lessonType.id">
            <td style="width: 40px;">{{ lessonType.id }}</td>
            <td class="text-left" style="display: flex; flex-direction: column;">
              <div :style="{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                width: '100%'
              }">
                <div>
                  <h5 class="display-4 mb-0">{{ lessonType.name_mgl }}</h5>
                  <span class="description">{{ lessonType.value }}</span>
                </div>
                <div style="width: 100px;">
                  <h6 :style="{
                        backgroundColor: lessonType.active ? '#d1fae5' : '#e5e7eb',
                        color: lessonType.active ? '#065f46' : '#4b5563',
                        padding: '4px 12px',
                        borderRadius: '9999px',
                        fontWeight: '500',
                        fontSize: '14px',
                        display: 'inline-block'
                      }"> {{ lessonType.active ? "Харуулах" : "Харуулахгүй" }} </h6>
                  <div>
                    <button type="button" rel="tooltip" class="btn btn-primary btn-icon btn-sm"
                    toggle="tooltip" data-placement="top" title="Дэд хичээлийн төрөл нэмэх"
                      @click="addLessonType(lessonType)">
                      <i class="fa fa-plus pt-1"></i>
                    </button>
                    <button type="button" rel="tooltip" class="btn btn-info btn-icon btn-sm"
                      @click="openEditModal(lessonType)">
                      <i class="fa fa-pencil pt-1"></i>
                    </button>
                  </div>
                </div>

              </div>

              <ul class="mt-2 ml-4">
                <li v-for="child in lessonType.childs" :key="child.id" style="list-style: disc; margin-bottom: 4px;">
                  <div :style="{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }">
                    <div>
                      <h5 class="display-5 mb-0">{{ child.name_mgl }}</h5>
                      <span class="description">{{ child.value }}</span>
                    </div>
                    <div style="width: 100px;">
                      <h6 :style="{
                        backgroundColor: child.active ? '#d1fae5' : '#e5e7eb',
                        color: child.active ? '#065f46' : '#4b5563',
                        padding: '4px 12px',
                        borderRadius: '9999px',
                        fontWeight: '500',
                        fontSize: '14px',
                        display: 'inline-block'
                      }"> {{ child.active ? "Харуулах" : "Харуулахгүй" }} </h6>
                      <button class="btn btn-sm btn-info btn-icon" @click="openEditModal(child)">
                        <i class="fa fa-pencil"></i>
                      </button>
                    </div>

                  </div>
                </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-else class="text-center py-4">
        <p class="h4 text-muted">Таны хайлтанд тохирох хичээлийн төрөл олдсонгүй.</p>
      </div>
    </div>

    <!-- Modal for Create/Edit -->
    <Modal :show.sync="showModal" class="modalOverlay">
      <div class="modal-header">
        <h3>{{ isEditing ? 'Засах' : 'Үүсгэх' }} хичээлийн төрөл</h3>
      </div>

      <form @submit.prevent="handleSubmit" class="modalForm">
        <div v-if="typeData.parent_name_mgl" class="form-group">
          <label>Үндсэн ангилал</label>
          <h4>{{ typeData.parent_name_mgl }}</h4>
        </div>

        <div class="form-group">
          <label>Нэр</label>
          <input v-model="typeData.name_mgl" class="form-control" type="text" required />
        </div>

        <div class="form-group">
          <label>Утга</label>
          <input v-model="typeData.value" class="form-control" type="text" required />
        </div>

        <div class="toggle">
          <input type="checkbox" v-model="typeData.active" :id="'status-toggle'" style="margin-bottom: 6px;" />
          <label :style="{
            backgroundColor: typeData.active ? '#d1fae5' : '#e5e7eb',
            color: typeData.active ? '#065f46' : '#4b5563',
            padding: '4px 12px',
            borderRadius: '9999px',
            fontWeight: '500',
            fontSize: '14px',
            display: 'inline-block'
          }">
            {{ typeData.active ? "Идэвхтэй" : "Идэвхгүй" }}
          </label>
        </div>

        <div class="modal-footer">
          <base-button type="link" class="cancelButton" @click="closeModal">Цуцлах</base-button>
          <base-button @click="handleSubmit" type="primary" class="saveButton">Хадгалах</base-button>
        </div>
      </form>
    </Modal>
  </card>
</template>

<script>
import axios from "axios";
import Modal from "@/components/Modal.vue";

export default {
  name: "LessonTypes",
  data() {
    return {
      typeList: [],
      typeData: {
        parent_name_mgl: "",
        parent_id: null,
        name_mgl: "",
        value: ""
      },
      showModal: false,
      searchQuery: "",
      sortDirection: "asc",
      isEditing: false,
    };
  },
  created() {
    this.fetchLessonTypeList();
  },
  components: {
    Modal,
  },
  computed: {
    filteredTypeList() {
      let types = [...this.typeList];

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        types = types.filter(parent =>
          parent.name_mgl.toLowerCase().includes(query) ||
          parent.value.toLowerCase().includes(query) ||
          parent.childs.some(
            child =>
              child.name_mgl.toLowerCase().includes(query) ||
              child.value.toLowerCase().includes(query)
          )
        );
      }

      types.sort((a, b) =>
        this.sortDirection === "asc" ? a.id - b.id : b.id - a.id
      );

      return types;
    },
  },
  methods: {
    fetchLessonTypeList() {
      axios.get("/lesson_types")
        .then(response => {
          const rawList = response.data;
          const parentMap = {};

          // Create parent items with empty `childs`
          rawList.forEach(item => {
            if (!item.parent_id) {
              parentMap[item.id] = { ...item, childs: [] };
            }
          });

          // Attach children to their parents
          rawList.forEach(item => {
            if (item.parent_id && parentMap[item.parent_id]) {
              parentMap[item.parent_id].childs.push({
                id: item.id,
                name_mgl: item.name_mgl,
                value: item.value,
                expanded: false,
                active: item.active
              });
            }
          });

          this.typeList = Object.values(parentMap);
        })
        .catch(error => {
          console.error("Хичээлийн төрлийн жагсаалтыг татаж чадсангүй:", error);
        });
    },

    toggleSort() {
      this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
    },

    toggleExpand(lesson_type) {
      lesson_type.expanded = !lesson_type.expanded;
    },

    openCreateModal() {
      this.isEditing = false;
      this.typeData = { name_mgl: "", value: "" };
      this.showModal = true;
    },

    addLessonType(lessonType) {
      this.typeData = {
        parent_name_mgl: lessonType.name_mgl,
        parent_id: lessonType.id,
        name_mgl: "",
        value: ""
      };
      this.isEditing = false;
      this.showModal = true;
    },

    openEditModal(type) {
      this.isEditing = true;
      this.typeData = { ...type };
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
      this.typeData = { name_mgl: "", value: "", active: true };
    },

    handleSubmit() {
      if (this.isEditing && this.typeData.id) {
        console.log('this.typeData', this.typeData);

        axios.put(`/lesson_type/${this.typeData.id}`, this.typeData)
          .then(() => {
            this.fetchLessonTypeList();
            this.closeModal();
          })
          .catch(error => {
            console.error("Засахад алдаа гарлаа:", error);
          });
      } else {
        axios.post(`/lesson_type`, this.typeData)
          .then(() => {
            this.fetchLessonTypeList();
            this.closeModal();
          })
          .catch(error => {
            console.error("Үүсгэхэд алдаа гарлаа:", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.btn-link {
  text-decoration: none;
  color: inherit;
  padding: 0;
}

.btn-link:hover {
  text-decoration: none;
  color: inherit;
}
</style>
